export const ERRORS_TYPES_URL = '/crm/errors/types';
export const ERRORS_TODAY_URL = '/crm/errors/today';
export const ERRORS_ALL_TIME_URL = '/crm/errors/yes';
export const ERRORS_DATE_URL = '/crm/errors/date';
export const ERRORS_URL = '/crm/errors/';
export const RESOLVE_URL = '/crm/resolve';
export const REPORT_URL = '/errors/report';
